import { render, staticRenderFns } from "./CartItemAmount.vue?vue&type=template&id=bc0c7818&"
import script from "./CartItemAmount.js?vue&type=script&lang=js&"
export * from "./CartItemAmount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports